import PdmUserNameSelect from "./index.vue";
var pdmUserNameSelect = {
  install: function install(Vue) {
    Vue.component("PdmUserNameSelect", PdmUserNameSelect);
  }
};
export default pdmUserNameSelect;